module.exports = __webpack_public_path__ + "static/ARTS_KAPAK-d5c6db0ca935b27bdc6962b3ba9b65fe.jpg";